export class TableInvalidConfigException extends Error {
  constructor(message?: string) {
    super(message);
  }
}
